<template>
  <div class="container-cap" id="bo-free-map">
    <color-range-selector
        v-model="colorRangeSelectorModal.show"
        :currentConfig="colorRangeSelectorModal.config"
        :options="colorRangeSelectorModal.options"
        :presets="colorRangeSelectorModal.presets"
        @save-color-ranges="setColorsRanges">
    </color-range-selector>
    <h1 class="text-primary">
      Carte libre
    </h1>
    <hr>
    <div class="panel panel-info">
      <div class="panel-heading">
        <btn class="btn-primary padded-button"
          @click="$refs.fileInput.click()">
          Importer depuis un .csv
          <input ref="fileInput"
            v-show="false"
            type="file"
            @change="importFromCSV"
            single>
        </btn>
        <btn class="btn-danger padded-button"
          @click="resetCsvData">
          Réinitialiser les données CSV
        </btn>
        <a class="btn btn-default padded-button"
          role="button"
          target="_blank"
          download="csv_vierge_carte.csv"
          :href="require(`@/assets/map/csv_vierge_carte.csv`)">
          Télécharger un CSV vierge
        </a>
        <div v-if="csvError.error">
          <br>
          <sui-error-panel :error="csvError" >
          </sui-error-panel>
        </div>
      </div>
    </div>
    <div class="row row-flex">
      <div class="col-xs-12 col-md-6">
        <div class="row color-config-container">
          <div class="col-xs-12 col-sm-6 col-md-12 col-lg-6">
            <div class="panel panel-default">
              <div class="panel-body text-center">
                <div>
                  <strong>Couleur de fond</strong>
                </div>
                <btn-group class="padded-element" :size="interfaceSize.btn">
                  <btn  v-for="(method, idx) in colorMethods"
                        :key="`pellets-method-btn-${method.key}-${idx}`"
                        v-model="colorsSettings.regions.method"
                        input-type="radio"
                        :input-value="method.key">
                    {{ method.btn }}
                  </btn>
                </btn-group>
                <div>
                  <div v-if="colorsMethods.regions.united" class="color-body">
                    <strong>France</strong>
                    <color-selector
                      centered
                      v-model="colorsSettings.regions.unifiedColor"
                      :defaultColor="colorsSettings.regions.defaultColor"
                      :customPalette="colorModules.regions.palette">
                    </color-selector>
                  </div>
                  <div v-else-if="colorsMethods.regions.range" class="color-body">
                    <btn @click="presetAndShowColorRangeSelectorModal(colorModules.regions.type)"
                      type="primary" :size="interfaceSize.btn">
                      Configurer les seuils
                    </btn>
                    <dropdown-selector
                      :label="rangeReference.regions.label"
                      :type="rangeReference.type"
                      :size="interfaceSize.btn"
                      :disabled="rangeReference.regions.disabled"
                      :lines="rangeReference.regions.lines">
                    </dropdown-selector>
                  </div>
                  <div v-else-if="colorsMethods.regions.predefined" class="color-body">
                    Colonne de référence
                    <dropdown-selector
                        :label="selectedCsvData.regionsHex.substring(0, 27)"
                        type="bactADI"
                        :size="interfaceSize.btn"
                        :lines="dropdownLists.colors.regions.hexValues">
                    </dropdown-selector>
                  </div>
                  <div v-else-if="selectedRegion == null" class="color-body">
                    <i>Cliquer sur une région pour définir sa couleur de fond.</i>
                  </div>
                  <div v-else class="color-body">
                    <strong>{{ selectedRegion.name }}</strong>
                    <color-selector centered
                      v-model="colorsSettings.regions.unitaryOptions[selectedRegion.key].bgColor"
                      :defaultColor="colorsSettings.regions.unitaryOptions[selectedRegion.key].bgColor"
                      :customPalette="colorModules.regions.palette">
                    </color-selector>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-12 col-lg-6">
            <div class="panel panel-default">
              <div class="panel-body text-center">
                <div>
                  <strong>Couleurs des pastilles</strong>
                </div>
                <btn-group class="padded-element" :size="interfaceSize.btn">
                  <btn  v-for="(method, idx) in colorMethods"
                        :key="`pellets-method-btn-${method.key}-${idx}`"
                        v-model="colorsSettings.pellets.method"
                        input-type="radio"
                        :input-value="method.key">
                    {{ method.btn }}
                  </btn>
                </btn-group>
                <div v-if="colorsMethods.pellets.united" class="color-body">
                  <strong>France</strong>
                  <color-selector
                    centered
                    v-model="colorsSettings.pellets.unifiedColor"
                    :defaultColor="colorsSettings.pellets.defaultColor"
                    :customPalette="colorModules.palette">
                  </color-selector>
                </div>
                <div v-else-if="colorsMethods.pellets.range" class="color-body">
                  <btn @click="presetAndShowColorRangeSelectorModal(colorModules.pellets.type)"
                    type="primary" :size="interfaceSize.btn">
                    Configurer les seuils
                  </btn>
                  <dropdown-selector
                    :label="rangeReference.pellets.label"
                    :type="rangeReference.type"
                    :size="interfaceSize.btn"
                    :disabled="rangeReference.pellets.disabled"
                    :lines="rangeReference.pellets.lines">
                  </dropdown-selector>
                </div>
                <div v-else-if="colorsMethods.pellets.predefined" class="color-body">
                  Colonne de référence
                  <dropdown-selector
                      :label="selectedCsvData.pelletsHex.substring(0, 27)"
                      type="bactADI"
                      :size="interfaceSize.btn"
                      :lines="dropdownLists.colors.pellets.hexValues">
                  </dropdown-selector>
                </div>
                <div v-else-if="selectedRegion == null" class="color-body">
                  <i>Cliquer sur une région pour définir la couleur de sa pastille</i>
                </div>
                <div v-else class="color-body">
                  <strong>{{ selectedRegion.name }}</strong>
                  <color-selector centered
                                  v-model="colorsSettings.pellets.unitaryOptions[selectedRegion.key].bgColor"
                                  :defaultColor="colorsSettings.pellets.unitaryOptions[selectedRegion.key].bgColor"
                                  :customPalette="colorModules.palette">
                  </color-selector>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-body text-center">
            <div>
              <strong>Affichage des pastilles</strong>
            </div>

            <div class="col-xs-12">
              <btn-group class="padded-element" :size="interfaceSize.btn">
                <btn  v-for="(method, idx) in pelletsStyles"
                      :key="`pellets-style-btn-${method.key}-${idx}`"
                      v-model="mapDisplayOptions.pelletsStyle"
                      input-type="radio"
                      :input-value="method.key">
                  {{ method.btn }}
                </btn>
              </btn-group>
              <br>
              <sui-checkbox v-model="mapDisplayOptions.addPercent.value1"
                            class="padded-element"
                            type="results"
                            :size="interfaceSize.checkbox">
                Pourcentage<span v-if="isPelletsStyle.twoValues"> valeur 1</span>
              </sui-checkbox>
              <sui-checkbox v-if="isPelletsStyle.twoValues"
                            v-model="mapDisplayOptions.addPercent.value2"
                            class="padded-element"
                            type="results"
                            :size="interfaceSize.checkbox">
                Pourcentage valeur 2
              </sui-checkbox>
            </div>

            <div class="row">
              <div :class="displayOptionsCols.textSize">
                <h5>Taille du texte</h5>
                <cleave class="form-control text-center"
                        :class="interfaceSize.cleaveClass"
                        v-model="mapDisplayOptions.pelletsFontSize"
                        name="value-pellet-font-siez"
                        autocomplete="off"
                        :options="fontSizeCleaveOptions">
                </cleave>
              </div>
              <div :class="displayOptionsCols.decimals">
                <h5>Décimales<span v-if="isPelletsStyle.twoValues"> 1</span></h5>
                <cleave class="form-control text-center"
                        :class="interfaceSize.cleaveClass"
                        v-model="mapDisplayOptions.decimal.value1"
                        name="value-pellet-font-size1"
                        autocomplete="off"
                        :options="decimalCleaveOptions">
                </cleave>
              </div>
              <div  v-if="isPelletsStyle.twoValues"
                    :class="displayOptionsCols.decimals">
                <h5>Décimales 2</h5>
                <cleave class="form-control text-center"
                        :class="interfaceSize.cleaveClass"
                        v-model="mapDisplayOptions.decimal.value2"
                        name="value-pellet-font-size2"
                        autocomplete="off"
                        :options="decimalCleaveOptions">
                </cleave>
              </div>
              <div :class="displayOptionsCols.percentDen"
                    class="text-center">
                <h5>
                  Dénominateur
                  <span v-if="isPelletsStyle.twoValues"> valeur 1
                  </span>
                </h5>
                <cleave class="form-control text-center"
                        :class="interfaceSize.cleaveClass"
                        v-model="mapDisplayOptions.percentValue"
                        :name="`value-percent-option`"
                        autocomplete="off"
                        :options="percentValueCleaveOptions">
                </cleave>
                <btn type="results" :size="interfaceSize.btn"
                     class="padded-button"
                     @click="setPercentValue('max')">
                  Max
                </btn>
                <btn type="results" :size="interfaceSize.btn"
                     class="padded-button"
                     @click="setPercentValue('sum')">
                  Total
                </btn>
                <btn type="results" :size="interfaceSize.btn"
                     class="padded-button"
                     @click="setPercentValue('none')">
                  Aucun
                </btn>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-info">
          <div class="panel-body">
            <div class="text-center">
              <strong>Valeurs des pastilles</strong>
              <div class="row">
                <div v-if="isCsvDataReady">
                  <div class="col-xs-12 padded-element">
                    <dropdown-selector
                        :label="selectedCsvData.forMapValues.substring(0, 27)"
                        prefix="Valeur 1"
                        type="bactADI" :size="interfaceSize.btn"
                        :lines="dropdownLists.map">
                    </dropdown-selector>
                  </div>
                  <div v-if="isPelletsStyle.twoValues">
                    <div class="col-xs-12 padded-element">
                      <dropdown-selector
                          :label="selectedCsvData.forMapValues2.substring(0, 27)"
                          prefix="Valeur 2"
                          :disabled="selectedCsvData.forMapValues === 'aucune'"
                          type="topCvp" :size="interfaceSize.btn"
                          :lines="dropdownLists.map2">
                      </dropdown-selector>
                    </div>
                  </div>
                </div>
                <div v-else class="padded-element">
                  <span :class="`label label-${valueStatus.style} status-message`">
                    {{valueStatus.msg}}
                  </span>
                </div>
                <div class="col-xs-12">
                  <btn-group class="padded-element" :size="interfaceSize.btn">
                    <btn v-model="regionsCollapse"
                         input-type="radio"
                         :input-value="false">
                      Région sélectionnée
                    </btn>
                    <btn v-model="regionsCollapse"
                         input-type="radio"
                         :input-value="true">
                      Toutes les régions
                    </btn>
                  </btn-group>
                </div>
              </div>
            </div>
            <collapse v-model="regionDetailCollapse" class="padded-element">
              <div class="text-center one-region-container">
                <div v-if="selectedRegion == null">
                  <i>Cliquez sur une région de la carte pour afficher ses options</i>
                </div>
                <div v-else>
                  <strong>{{selectedRegion.name}}</strong>
                  <div v-if="isPelletsStyle.twoValues" class="selected-region-container">
                    <table class="table-responsive table" style="width:40%">
                      <thead>
                      <tr>
                        <th scope="col" class="text-center">Valeur 1</th>
                        <th scope="col" class="text-center">Valeur 2</th>
                        <th scope="col" class="text-center">
                          <span class="glyphicon glyphicon-eye-close"></span>
                        </th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <cleave class="form-control text-center"
                                    :class="interfaceSize.cleaveClass"
                                    v-model="mapValues[selectedRegion.key]"
                                    :name="`value1-${selectedRegion.key}`"
                                    autocomplete="off"
                                    :disabled="isCsvDataReady"
                                    :options="mapValuesCleavesOptions[selectedRegion.key]">
                            </cleave>
                          </td>
                          <td>
                            <cleave class="form-control text-center"
                                    :class="interfaceSize.cleaveClass"
                                    v-model="mapValues2[selectedRegion.key]"
                                    :name="`value2-${selectedRegion.key}`"
                                    autocomplete="off"
                                    :disabled="isCsvDataReady"
                                    :options="mapValuesCleavesOptions[selectedRegion.key]">
                            </cleave>
                          </td>
                          <td>
                            <sui-checkbox v-model="colorsSettings.pellets.unitaryOptions[selectedRegion.key].forceHide"
                                          type="results"
                                          :empty="true"
                                          :size="interfaceSize.checkbox">
                            </sui-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="selected-region-container">
                    <div>
                    <cleave class="form-control text-center"
                            :class="interfaceSize.cleaveClass"
                            v-model="mapValues[selectedRegion.key]"
                            :name="`value-${selectedRegion.key}`"
                            autocomplete="off"
                            :disabled="isCsvDataReady"
                            :options="mapValuesCleavesOptions[selectedRegion.key]">
                    </cleave>
                    </div>
                    <sui-checkbox v-model="colorsSettings.pellets.unitaryOptions[selectedRegion.key].forceHide"
                                  type="results"
                                  :size="interfaceSize.checkbox">
                      Masquer
                    </sui-checkbox>
                  </div>
                </div>
              </div>
            </collapse>
            <collapse v-model="regionsCollapse">
              <div class="row">
                <div v-for="tableNum in 2"
                     :key="`region-table-${tableNum}`"
                     class="col-xs-12 col-sm-6 col-md-12 col-lg-6">
                  <table class="table-responsive table">
                    <thead>
                      <tr>
                        <th scope="col"
                            :style="tableContentStyle.region">
                          Région
                        </th>
                        <th scope="col"
                            class="text-center"
                            :style="tableContentStyle.value">
                          Valeur<span v-if="isPelletsStyle.twoValues"> 1</span>
                        </th>
                        <th v-if="isPelletsStyle.twoValues"
                            scope="col"
                            class="text-center"
                            :style="tableContentStyle.value">
                          Valeur 2
                        </th>
                        <th scope="col" class="text-center">
                          <span class="glyphicon glyphicon-eye-close"></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(a, b) in regionsList.slice((tableNum - 1) * 9, tableNum * 9)"
                          :key="`data-setup-${a.key}-${b}`">
                        <th scope="row" :style="tableContentStyle.region">{{a.name}}</th>
                        <td class="text-center" :style="tableContentStyle.value">
                          <cleave class="form-control center-block text-center"
                                  :class="interfaceSize.cleaveClass"
                                  v-model="mapValues[a.key]"
                                  :name="`value-${a.key}`"
                                  autocomplete="off"
                                  :disabled="isCsvDataReady"
                                  :options="mapValuesCleavesOptions[a.key]">
                          </cleave>
                        </td>
                        <td v-if="isPelletsStyle.twoValues"
                            class="text-center" :style="tableContentStyle.value">
                          <cleave class="form-control center-block text-center"
                                  :class="interfaceSize.cleaveClass"
                                  v-model="mapValues2[a.key]"
                                  :name="`value2-${a.key}`"
                                  autocomplete="off"
                                  :disabled="isCsvDataReady"
                                  :options="mapValuesCleavesOptions[a.key]">
                          </cleave>
                        </td>
                        <td class="text-center">
                          <sui-checkbox v-model="colorsSettings.pellets.unitaryOptions[a.key].forceHide"
                                  type="results"
                                  size="sm"
                                  :empty="true">
                          </sui-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </collapse>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5">
        <france-map
            v-model="selectedRegion"
            :mapData="mapValues"
            :mapData2="mapValues2"
            :displayPellets="showMapPellets"
            :pelletsColors="pelletsMapColors"
            :regionsColors="regionsMapColors"
            :displayOptions="mapDisplayOptions">
        </france-map>
      </div>
    </div>
  </div>
</template>
<script>
import assert from '@/sui/tools/assert'
import c from '@/tools/colors/colors'

import colorRangeSelector from '@/components/map/colorrangeselector'
import colorSelector from '@/components/map/colorselector'
import franceMap from '@/components/map/francemap'
import franceMapData from '@/sc/francemap'

import suiErrorPanel from '@/sui/components/errorpanel'
import dropdownSelector from '@/sui/components/results/dropdownSelector'
import suiCheckbox from '@/sui/components/checkbox'
import Error from '@/sui/tools/error'

import common from '@/components/map/impl/common'
import impl from '@/views/tools/impl/map'
import parse from 'csv-parse'
import cleave from 'vue-cleave-component'

const defaultPelletBgColor = franceMapData.defaultPelletBgColor
const defaultRegionBgColor = franceMapData.defaultRegionBgColor

const colorModules = {
  pellets: {
    type: 'pellets',
    title: 'pastilles',
    palette: c.mapPalettes.pellets
  },
  regions: {
    type: 'regions',
    title: 'régions',
    palette: c.mapPalettes.regions
  }
}

const noValueSelectedText = 'aucune'

const csvValuesTypes = {
  float: 'valeur numérique',
  color: 'couleur',
  unknown: ''
}

const dropdownDefaultText = 'Colonne de référence'
const defaultMapValues1 = franceMapData.defaultMapValues()
const defaultMapValues2 = franceMapData.defaultMapValues()

class ResizeListener {
  constructor () {
    this.size = null
  }

  updateSize () {
    this.size = {
      width: window.innerWidth,
      height: window.innerHeight
    }
  }

  initialize () {
    this.updateSize()
    window.addEventListener('resize', this)
  }

  finalize () {
    window.removeEventListener('resize', this)
  }

  handleEvent (e) {
    this.updateSize()
  }
}

export default {
  name: 'bo-free-map',

  data: function () {
    return {
      palettes: c.mapPalettes,
      resizeListener: new ResizeListener(),
      dropdownDefaultText: dropdownDefaultText,
      pelletsStyles: [
        {
          key: 'round',
          btn: 'Arrondies'
        },
        {
          key: 'roundDouble',
          btn: 'Arrondies (2 valeurs)'
        },
        {
          key: 'incidence',
          btn: 'Incidence'
        },
        {
          key: 'incidenceDouble',
          btn: 'Incidence (2 valeurs)'
        }
      ],
      selectedRegion: null,
      regionsCollapse: false,
      colorModules: colorModules,
      csvFile: null,
      rawCsvData: null,
      colorsSettings: {
        pellets: {
          modalConfig: [],
          method: 'united',
          customColorsRanges: null,
          colorGradient: false,
          unifiedColor: defaultPelletBgColor,
          defaultColor: defaultPelletBgColor,
          unitaryOptions: franceMapData.defaultPelletsOptions(),
          presets: franceMapData.defaultPelletPresets
        },
        regions: {
          modalConfig: [],
          method: 'united',
          customColorsRanges: null,
          colorGradient: false,
          unifiedColor: defaultRegionBgColor,
          defaultColor: defaultRegionBgColor,
          unitaryOptions: franceMapData.defaultRegionsOptions(),
          presets: franceMapData.defaultRegionsPresets
        }
      },
      selectedCsvData: {
        forMapValues: noValueSelectedText,
        forMapValues2: noValueSelectedText,
        regions: dropdownDefaultText,
        pellets: dropdownDefaultText,
        regionsHex: noValueSelectedText,
        pelletsHex: noValueSelectedText
      },
      valueStatus: {
        msg: 'Saisie manuelle',
        style: 'expADI'
      },
      csvError: new Error(),
      colorRangeSelectorModal: {
        show: false,
        type: null,
        config: [],
        options: { colorGradient: false },
        presets: { selected: null, sc: null }
      },
      defaultMap: {
        values1: defaultMapValues1,
        values2: defaultMapValues2
      },
      manualEntryMap: {
        values1: defaultMapValues1,
        values2: defaultMapValues2
      },
      regionsList: franceMapData.regionsList(),
      mapDisplayOptions: franceMapData.defaultMapDisplayOptions(),
      pelletsStylesDisplay: franceMapData.pelletsStylesDisplay(),
      percentValueCleaveOptions: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 10,
        numeralThousandsGroupStyle: 'none',
        numeralDecimalScale: 0
      },
      fontSizeCleaveOptions: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 2,
        numeralDecimalScale: 0
      },
      decimalCleaveOptions: {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 1,
        numeralDecimalScale: 0
      }
    }
  },

  watch: {
    csvFile (value) {
      if (value == null) {
        return
      }
      this.resetCsvData()
      this.rawCsvData = null
      const file = value
      const reader = new FileReader()
      reader.onload = this.parseCSV
      reader.readAsText(file)
    },

    'mapDisplayOptions.pelletsStyle': function (v) {
      const style = this.pelletsStylesDisplay[v]
      assert.notNull(style)

      const keys = Object.keys(style)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        this.mapDisplayOptions[key] = style[key]
      }
    }
  },

  mounted: function () {
    this.resizeListener.initialize()
    this.resetCsvData()
  },

  unmounted: function () {
    this.resizeListener.finalize()
    this.resetCsvData()
  },

  computed: {
    rangeReference: function () {
      if (this.isCsvDataReady) {
        const characterLimit = 20
        return {
          type: 'bactADI',
          pellets: {
            disabled: this.colorsSettings.pellets.modalConfig.length === 0,
            lines: this.dropdownLists.colors.pellets.numericValues,
            label: this.selectedCsvData.pellets.substring(0, characterLimit)
          },
          regions: {
            disabled: this.colorsSettings.regions.modalConfig.length === 0,
            lines: this.dropdownLists.colors.regions.numericValues,
            label: this.selectedCsvData.regions.substring(0, characterLimit)
          }
        }
      }

      if (!this.isPelletsStyle.twoValues) {
        return {
          type: 'bactADI',
          pellets: {
            lines: [],
            disabled: true,
            label: 'Saisie manuelle'
          },
          regions: {
            lines: [],
            disabled: true,
            label: 'Saisie manuelle'
          }
        }
      }

      return {
        type: 'expADI',
        pellets: {
          lines: [],
          disabled: true,
          label: 'Valeur 1'
        },
        regions: {
          lines: [],
          disabled: true,
          label: 'Valeur 2'
        }
      }
    },

    interfaceSize: function () {
      if (this.resizeListener.size == null) {
        return ''
      }

      let result = {
        checkbox: 'sm',
        btn: 'sm',
        cleaveClass: 'cleave-sm'
      }

      if (this.resizeListener.size.width < 1200) {
        result = {
          checkbox: 'xs',
          btn: 'xs',
          cleaveClass: 'cleave-xs'
        }
      }

      return result
    },

    isCsvDataReady: function () {
      const formatedCsvData = this.formatedCsvData
      const dropdownLists = this.dropdownLists
      if (formatedCsvData == null || dropdownLists == null) {
        return false
      }

      return !(formatedCsvData.values == null ||
          dropdownLists.map == null ||
          dropdownLists.colors == null)
    },

    colorMethods: function () {
      const methods = [
        {
          key: 'united',
          btn: 'Unique'
        },
        {
          key: 'manual',
          btn: 'Par région'
        },
        {
          key: 'range',
          btn: `Par valeurs`
        }
      ]

      if (this.hasCsvHexPredefinedColors) {
        methods.push(
          {
            key: 'predefined',
            btn: 'CSV'
          }
        )
      }
      return methods
    },

    mapValues: function () {
      return this.getMapValues(
        this.selectedCsvData.forMapValues,
        this.dropdownLists.map,
        this.manualEntryMap.values1
      )
    },

    mapValues2: function () {
      if (!this.isPelletsStyle.twoValues) {
        return {}
      }
      return this.getMapValues(
        this.selectedCsvData.forMapValues2,
        this.dropdownLists.map2,
        this.manualEntryMap.values2
      )
    },

    showMapPellets: function () {
      const values = this.mapValues
      if (values == null) {
        return null
      }

      const result = {}
      const regionsList = this.regionsList
      const settings = this.colorsSettings.pellets
      for (let i = 0; i < regionsList.length; i++) {
        const regionKey = regionsList[i].key
        const value = values[regionKey]
        const forceHidePellet = settings.unitaryOptions[regionKey].forceHide

        result[regionKey] = forceHidePellet
          ? false : !(value === '' || value == null)
      }
      return result
    },

    selectedValuesForPelletsColors: function () {
      if (this.colorsMethods.pellets.predefined) {
        const sel = this.selectedCsvData.pelletsHex
        common.dropdown.highlightItem(
          this.dropdownLists.colors.pellets.hexValues,
          sel
        )
        return this.getCsvValues(sel)
      }

      const sel = this.selectedCsvData.pellets
      const defaultValue = this.dropdownDefaultText

      if (this.isCsvDataReady) {
        common.dropdown.highlightItem(
          this.dropdownLists.colors.pellets.numericValues,
          sel
        )
      }

      if (defaultValue === sel) {
        return this.mapValues
      }

      return this.getCsvValues(sel)
    },

    selectedValuesForRegionsColors: function () {
      if (this.colorsMethods.regions.predefined) {
        const sel = this.selectedCsvData.regionsHex
        common.dropdown.highlightItem(
          this.dropdownLists.colors.regions.hexValues,
          sel
        )
        return this.getCsvValues(sel)
      }

      const sel = this.selectedCsvData.regions
      const defaultValue = this.dropdownDefaultText

      if (this.isCsvDataReady) {
        common.dropdown.highlightItem(
          this.dropdownLists.colors.regions.numericValues,
          sel
        )
      }

      if (defaultValue === sel) {
        if (this.isPelletsStyle.twoValues) {
          return this.mapValues2
        }

        return this.mapValues
      }

      return this.getCsvValues(sel)
    },

    colorsMethods: function () {
      const cs = this.colorsSettings
      const pelletMethod = cs.pellets.method
      const regionsMethod = cs.regions.method

      return {
        pellets: {
          united: pelletMethod === 'united',
          manual: pelletMethod === 'manual',
          range: pelletMethod === 'range',
          predefined: pelletMethod === 'predefined'
        },
        regions: {
          united: regionsMethod === 'united',
          manual: regionsMethod === 'manual',
          range: regionsMethod === 'range',
          predefined: regionsMethod === 'predefined'
        }
      }
    },

    isRangeMethodReady: function () {
      const settings = this.colorsSettings
      const pelletsSettings = settings.pellets
      const regionsSettings = settings.regions
      const methods = this.colorsMethods
      const isRangePelletsMethod = methods.pellets.range
      const isRangeRegionsMethod = methods.regions.range
      const isTresholdsForPellets = pelletsSettings.customColorsRanges != null
      const isTresholdsForRegions = regionsSettings.customColorsRanges != null

      return {
        pellets: isRangePelletsMethod && isTresholdsForPellets,
        regions: isRangeRegionsMethod && isTresholdsForRegions
      }
    },

    pelletsMapColors: function () {
      const result = {}

      const regionsList = this.regionsList
      const settings = this.colorsSettings.pellets
      const method = this.colorsMethods.pellets
      const defaultColor = settings.defaultColor
      const colorTresholdsConfig = settings.modalConfig
      const colorGradient = settings.colorGradient

      for (let i = 0; i < regionsList.length; i++) {
        const regionKey = regionsList[i].key

        if (method.united) {
          result[regionKey] = settings.unifiedColor
          continue
        }

        if (method.manual) {
          result[regionKey] = settings.unitaryOptions[regionKey].bgColor
          continue
        }

        const value = this.selectedValuesForPelletsColors[regionKey]
        if (value != null) {
          if (this.isRangeMethodReady.pellets) {
            result[regionKey] = {
              hex8: c.colorSelector(
                value,
                defaultColor,
                colorTresholdsConfig,
                colorGradient
              )
            }
            continue
          }
          if (this.colorsMethods.pellets.predefined &&
              value !== '') {
            result[regionKey] = { hex8: value }
            continue
          }
        }

        result[regionKey] = defaultColor
      }
      return result
    },

    regionsMapColors: function () {
      const result = {}

      const regionsList = this.regionsList
      const settings = this.colorsSettings.regions
      const method = this.colorsMethods.regions
      const defaultColor = settings.defaultColor
      const colorTresholdsConfig = settings.modalConfig
      const colorGradient = settings.colorGradient

      for (let i = 0; i < regionsList.length; i++) {
        const regionKey = regionsList[i].key

        if (method.united) {
          result[regionKey] = settings.unifiedColor
          continue
        }

        if (method.manual) {
          result[regionKey] = settings.unitaryOptions[regionKey].bgColor
          continue
        }

        const value = this.selectedValuesForRegionsColors[regionKey]
        if (value != null) {
          if (this.isRangeMethodReady.regions) {
            result[regionKey] = {
              hex8: c.colorSelector(
                value,
                defaultColor,
                colorTresholdsConfig,
                colorGradient
              )
            }
            continue
          }
          if (this.colorsMethods.regions.predefined &&
              value !== '') {
            result[regionKey] = { hex8: value }
            continue
          }
        }

        result[regionKey] = defaultColor
      }
      return result
    },

    regionDetailCollapse: function () {
      return !this.regionsCollapse
    },

    formatedCsvData: function () {
      function getValueAndType (rawValue) {
        if (rawValue === '') {
          return {
            vType: csvValuesTypes.float,
            value: ''
          }
        }

        const v = rawValue.replace(/,/g, '.')
        const floatValue = parseFloat(v)
        if (!isNaN(floatValue)) {
          return {
            vType: csvValuesTypes.float,
            value: floatValue
          }
        }

        const regex = /^#[0-9a-fA-F]{6}$/
        if (regex.test(v)) {
          return {
            vType: csvValuesTypes.color,
            value: v
          }
        }

        return {
          vType: csvValuesTypes.unknown,
          value: null
        }
      }

      const rawData = this.rawCsvData
      if (rawData == null) {
        return null
      }

      const csvHeader = [...Object.keys(rawData[0])]
      const nomsRegionsIndex = csvHeader.indexOf('nomsRegions')
      const codesRegionsIndex = csvHeader.indexOf('codesRegions')
      if (nomsRegionsIndex === -1 || codesRegionsIndex === -1) {
        this.setCSVError(
          'Entête invalide', 'Colonne(s) <strong>nomsRegions</strong> et/ou <strong>codesRegions</strong> manquant(es).'
        )
        return null
      }

      csvHeader.splice(nomsRegionsIndex, 1)
      csvHeader.splice(codesRegionsIndex, 1)

      const result = {}
      const uniqRegionsCodes = []
      const columnTypes = []
      for (let i = 0; i < rawData.length; i++) {
        const line = rawData[i]
        const regionCode = line.codesRegions
        const linePrefix = `Ligne <strong>${i + 1}</strong>`

        const isValidRegionCode =
            this.regionsList.findIndex(v => v.key === regionCode) !== -1
        if (!isValidRegionCode) {
          this.setCSVError(linePrefix, `Code région invalide : <strong>«${regionCode}»</strong>.`)
          return null
        }
        if (uniqRegionsCodes.includes(regionCode)) {
          this.setCSVError(linePrefix, `Code région en double : <strong>«${regionCode}»</strong>.`)
          return null
        }
        uniqRegionsCodes.push(regionCode)

        const values = {}
        for (let j = 0; j < csvHeader.length; j++) {
          const valueName = csvHeader[j]
          const rawValue = line[valueName]
          const { vType, value } = getValueAndType(rawValue)
          const prefix = `${linePrefix}, Colonne <strong>${j + 1}</strong> (${valueName})`

          if (vType === csvValuesTypes.unknown) {
            this.setCSVError(
              prefix, `Type inconnu pour la cellule <strong>«${rawValue}»</strong>.`
            )
            return null
          }

          if (i === 0) {
            columnTypes.push(vType)
          } else {
            const knownColumnType = columnTypes[j]
            if (knownColumnType !== vType) {
              this.setCSVError(
                prefix, `Type <strong>${vType}</strong> inattendu pour cette cellule car la colonne est de type <strong>${knownColumnType}</strong>.`
              )
              return null
            }
          }
          values[valueName] = value
        }

        if (i === 0) {
          assert(columnTypes.length === csvHeader.length)
        }
        result[regionCode] = values
      }

      this.setValueStatus('Fichier chargé', 'bactADI')
      return {
        values: result,
        header: csvHeader,
        columnTypes: columnTypes
      }
    },

    dropdownLists: function () {
      const data = this.formatedCsvData
      const result = {
        map: null,
        colors: null
      }

      if (data == null) {
        return result
      }

      const mapValuesNames = []
      const mapValuesNames2 = []

      const colorsLists = {
        pellets: {
          numericValues: [],
          hexValues: []
        },
        regions: {
          numericValues: [],
          hexValues: []
        }
      }

      const defaultText = this.dropdownDefaultText
      const sel = this.selectedCsvData

      common.dropdown.addItem(
        mapValuesNames,
        noValueSelectedText,
        function () { sel.forMapValues = noValueSelectedText },
        true
      )
      common.dropdown.addItem(
        mapValuesNames2,
        noValueSelectedText,
        function () { sel.forMapValues2 = noValueSelectedText },
        true
      )
      common.dropdown.addItem(
        colorsLists.pellets.numericValues,
        defaultText,
        function () { sel.pellets = defaultText },
        true
      )
      common.dropdown.addItem(
        colorsLists.regions.numericValues,
        defaultText,
        function () { sel.regions = defaultText },
        true
      )
      common.dropdown.addItem(
        colorsLists.pellets.hexValues,
        noValueSelectedText,
        function () { sel.pelletsHex = noValueSelectedText },
        true
      )
      common.dropdown.addItem(
        colorsLists.regions.hexValues,
        noValueSelectedText,
        function () { sel.regionsHex = noValueSelectedText },
        true
      )

      const variablesNames = data.header
      const variablesTypes = data.columnTypes
      for (let i = 0; i < variablesNames.length; i++) {
        const variableName = variablesNames[i]
        const variableType = variablesTypes[i]

        if (variableType === csvValuesTypes.float) {
          common.dropdown.addItem(
            mapValuesNames,
            variableName,
            function () { sel.forMapValues = variableName }
          )
          common.dropdown.addItem(
            mapValuesNames2,
            variableName,
            function () { sel.forMapValues2 = variableName }
          )
          common.dropdown.addItem(
            colorsLists.pellets.numericValues,
            variableName,
            function () { sel.pellets = variableName }
          )
          common.dropdown.addItem(
            colorsLists.regions.numericValues,
            variableName,
            function () { sel.regions = variableName }
          )
        } else if (variableType === csvValuesTypes.color) {
          common.dropdown.addItem(
            colorsLists.pellets.hexValues,
            variableName,
            function () { sel.pelletsHex = variableName }
          )
          common.dropdown.addItem(
            colorsLists.regions.hexValues,
            variableName,
            function () { sel.regionsHex = variableName }
          )
        }
      }

      return {
        map: mapValuesNames,
        map2: mapValuesNames2,
        colors: colorsLists
      }
    },

    hasCsvHexPredefinedColors: function () {
      if (!this.isCsvDataReady) {
        return false
      }

      const ddl = this.dropdownLists
      return ddl.colors.regions.hexValues.length > 1 &&
          ddl.colors.pellets.hexValues.length > 1
    },

    tresholdTexts: function () {
      const needToDefineText = 'sont à définir ici'
      const configOkText = 'ont été configurés'
      const nextText = 'et déterminent la couleur'
      const isCsvLoaded = this.isCsvDataReady
      const isRangeReady = this.isRangeMethodReady
      const isPelletsRangeReady = isRangeReady.pellets
      const isRegionsRangeReady = isRangeReady.regions

      return {
        pellets: {
          btn: isPelletsRangeReady ? configOkText : needToDefineText,
          sentenceEnd: isCsvLoaded && isPelletsRangeReady ? nextText : '!'
        },
        regions: {
          btn: isRegionsRangeReady ? configOkText : needToDefineText,
          sentenceEnd: isCsvLoaded && isRegionsRangeReady ? nextText : '!'
        }
      }
    },

    mapValuesCleavesOptions: function () {
      const regionList = this.regionsList
      const values = this.mapValues
      const isCsv = this.isCsvDataReady
      const result = {}

      for (let i = 0; i < regionList.length; i++) {
        const defaultOptions = {
          numeral: true,
          numeralThousandsGroupStyle: 'none',
          numeralIntegerScale: 4
        }

        const regionKey = regionList[i].key
        if (isCsv) {
          defaultOptions.numeralDecimalScale = 10
          result[regionKey] = defaultOptions
          continue
        }

        const v = values[regionKey]
        if (v == null || v === '') {
          result[regionKey] = defaultOptions
          continue
        }

        const isInteger = v.indexOf('.') === -1
        if (isInteger) {
          result[regionKey] = defaultOptions
          continue
        }

        const splitedNumber = v.split('.')
        const decimals = splitedNumber[1]
        if (decimals == null) {
          result[regionKey] = defaultOptions
          continue
        }

        const decimalScale = 4
        const integerCount = splitedNumber[0].length
        defaultOptions.numeralDecimalScale = decimalScale - integerCount
        result[regionKey] = defaultOptions
      }
      return result
    },

    isPelletsStyle: function () {
      return impl.askPelletsStyle(
        this.mapDisplayOptions.pelletsStyle
      )
    },

    tableContentStyle: function () {
      const w = 'width: '
      if (this.isPelletsStyle.twoValues) {
        return {
          region: `${w}40%`,
          value: `${w}30%`
        }
      }
      return {
        region: `${w}65%`,
        value: `${w}30%`
      }
    },

    displayOptionsCols: function () {
      if (this.isPelletsStyle.twoValues) {
        return {
          textSize: 'col-xs-12 col-sm-6 col-md-4 col-lg-2',
          decimals: 'col-xs-12 col-sm-6 col-md-4 col-lg-2',
          percentDen: 'col-xs-12 col-sm-6 col-md-4 col-lg-6'

        }
      }
      return {
        textSize: 'col-xs-12 col-sm-6 col-md-4 col-lg-3',
        decimals: 'col-xs-12 col-sm-6 col-md-4 col-lg-3',
        percentDen: 'col-xs-12 col-sm-6 col-md-4 col-lg-6'
      }
    }
  },

  methods: {
    getCsvValues: function (sel) {
      const regionsList = this.regionsList
      const formatedCsvData = this.formatedCsvData
      const result = {}

      if (formatedCsvData == null) {
        return result
      }

      const csvData = formatedCsvData.values
      if (csvData == null) {
        return result
      }

      for (let i = 0; i < regionsList.length; i++) {
        const regionKey = regionsList[i].key
        const regionData = csvData[regionKey]

        if (regionData == null) {
          result[regionKey] = ''
          continue
        }

        const selectedRegionData = regionData[sel]
        result[regionKey] =
              selectedRegionData == null ? ''
                : selectedRegionData
      }

      return result
    },

    getMapValues: function (
      selectedValueName,
      dropdown,
      manualEntryValues
    ) {
      const formatedCsvData = this.formatedCsvData

      if (this.isCsvDataReady &&
          formatedCsvData != null) {
        common.dropdown.highlightItem(
          dropdown,
          selectedValueName
        )

        if (selectedValueName === noValueSelectedText) {
          return franceMapData.defaultMapValues()
        }

        const csvValues = formatedCsvData.values
        const result = {}

        for (let regionName in csvValues) {
          const value = csvValues[regionName][selectedValueName]
          result[regionName] = isNaN(value)
            ? '' : `${value}`
        }

        return result
      }

      return manualEntryValues
    },

    setPercentValue: function (opt) {
      if (opt === 'none') {
        this.mapDisplayOptions.percentValue = null
        return
      }

      const mapData = this.mapValues
      let total = 0
      let max = 0

      for (let regionCodes in mapData) {
        const regionValue = mapData[regionCodes]
        if (regionValue == null || regionValue === '') {
          continue
        }
        const floatRegionValue = parseFloat(regionValue)
        total = total + floatRegionValue
        if (floatRegionValue > max) {
          max = floatRegionValue
        }
      }

      const mapDisplayOptions = this.mapDisplayOptions
      if (opt === 'max') {
        mapDisplayOptions.percentValue = max
      } else if (opt === 'sum') {
        mapDisplayOptions.percentValue = total
      }
    },

    presetAndShowColorRangeSelectorModal: function (type) {
      const modalSettings = this.colorRangeSelectorModal
      const editedSettings = this.getSettings(type)
      assert.notNull(editedSettings)

      modalSettings.type = type
      modalSettings.options.colorGradient = editedSettings.colorGradient
      modalSettings.config = editedSettings.modalConfig
      modalSettings.presets = editedSettings.presets
      modalSettings.show = true
    },

    getSettings: function (type) {
      if (type == null) {
        return null
      }
      return this.colorsSettings[type]
    },

    resetCsvData: function () {
      this.rawCsvData = null
      this.csvFile = null
      this.csvError.reset()
      const defaultText = this.dropdownDefaultText

      this.colorsSettings.regions.method = 'united'
      this.colorsSettings.pellets.method = 'united'

      this.selectedCsvData = {
        forMapValues: noValueSelectedText,
        forMapValues2: noValueSelectedText,
        regions: defaultText,
        pellets: defaultText,
        regionsHex: noValueSelectedText,
        pelletsHex: noValueSelectedText
      }

      this.setValueStatus('Saisie manuelle')
    },

    setValueStatus: function (msg, style = 'expADI') {
      const r = this.valueStatus
      r.style = style
      r.msg = msg
    },

    setCSVError: function (location, msg) {
      this.csvError.set(
        `Impossible d'importer le fichier CSV`,
        location,
        msg,
        false
      )
    },

    importFromCSV: function (event) {
      this.csvFile = event.target.files[0]
      this.$refs.fileInput.value = ''
    },

    parseCSV: function (e) {
      const vm = this
      parse(
        e.target.result,
        {
          columns: true,
          delimiter: ';',
          skip_empty_lines: true
        },
        (err, output) => {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible de charger le fichier csv: ${err}.`
            })
          } else if (output.length === 0) {
            vm.$notify({
              type: 'warning',
              title: 'Attention !',
              content: `Le fichier ne contient aucune donnée.`
            })
          } else {
            vm.rawCsvData = output
          }
        }
      )
    },

    setColorsRanges: function (v) {
      if (v == null) {
        return
      }
      const type = this.colorRangeSelectorModal.type
      const settings = this.getSettings(type)
      settings.modalConfig = v.config
      settings.colorGradient = v.colorGradient
      settings.customColorsRanges = { colorSelector: v.colorSelector }

      const presets = settings.presets
      if (presets != null) {
        presets.selected = v.selectedPreset
      }
    }
  },

  components: {
    'color-range-selector': colorRangeSelector,
    'color-selector': colorSelector,
    'franceMap': franceMap,
    cleave,
    'sui-checkbox': suiCheckbox,
    'dropdown-selector': dropdownSelector,
    'sui-error-panel': suiErrorPanel
  }
}

</script>
<style scoped>
.padded-element {
  padding-top: 6px;
  padding-right: 4px;
  padding-bottom: 6px;
}

.padded-button {
  margin-top: 4px;
  margin-right: 4px;
}

.row-flex {
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  padding-bottom: 20px;
}

.status-message {
  font-size: 13px;
}

.color-body {
  min-height: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
}

.selected-region-container {
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
  width: 100%;
  justify-content: center;
}

.one-region-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 54px;
}

.panel-body {
  padding: 0.4rem;
}

.cleave-xs {
  max-height: 28px;
}

.cleave-sm {
  max-height: 30px;
}
</style>
